import { render, staticRenderFns } from "./ProductProperty.vue?vue&type=template&id=35c6d14a&scoped=true&lang=pug&"
import script from "./ProductProperty.vue?vue&type=script&lang=js&"
export * from "./ProductProperty.vue?vue&type=script&lang=js&"
import style0 from "./ProductProperty.vue?vue&type=style&index=0&id=35c6d14a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c6d14a",
  null
  
)

export default component.exports